<template>
  <div
    v-bind="
      $ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'internalName'
      })
    "
  >
    <LibRichTextRenderer
      v-if="item.fields.content"
      :rich-text="item.fields.content"
      :has-light-vertical-header="item.fields?.hasLightVerticalHeader ?? false"
      :cols="mapColsWidth(item.fields.tableWidth) ?? 12"
      :cols-centered="item.fields?.colsCentered ?? true"
      :content-centered="item.fields?.contentCentered ?? false"
    />
  </div>
</template>

<script setup lang="ts">
import type { ITable } from '~~/lib/ContentfulService';
import { mapColsWidth } from '~/utils/mapColsWidth';
const { $ContentfulLivePreview } = useNuxtApp();

interface Props {
  item: ITable;
}

defineProps<Props>();
</script>
